import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Icon, Card, Divider } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import userProfileImageHolder from '../user_profile.jpg';
import moment from 'moment';
import Image from 'react-image-resizer';

const API_HOST_URL = process.env.REACT_APP_API_URL

const style = {
    profileImage: {
        display: 'inline',
        margin: '0 auto',
        // marginLeft: '-25%',
        height: '100%',
        width: 'auto'
    },
    
};

class Dashboard extends Component {
    state = {
        user: {}
    }

    componentDidMount() {
        const userId = this.props.loggedInUser.pk
        console.log("get user: ", userId)
        axios.get(`${API_HOST_URL}/api/userprofile/users/${userId}/`,{
            headers: {Authorization: 'Token ' + this.props.token}  
        })
            .then(res => {
                this.setState({
                    user: res.data
                })

                console.log("User Info: ", res.data);
            })
            .catch(err => {
                console.log("Error: ", JSON.stringify(err));
            })
    }

    isEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    render() {
        const { user } = this.state;

        return (
            <div>
                <Card>
                    <Row>
                        <Col md={{ span: 4, offset: 3 }}>
                            { this.isEmpty(user) == false &&
                            <div>
                                {   user.profile.profilePhoto !== null && 
                                    <div className="image-cropper-dashboard">
                                        <Image
                                            src={(user && user.profile !== null) ? (user && user.profile.profilePhoto) : userProfileImageHolder}
                                            height={200}
                                            width={200}
                                            style={style.profileImage}
                                        />
                                    </div>
                                }
                            {/* <h3 style={{ fontWeight: "bold" }} className="GrayText">{(user && user.first_name) + ' ' + (user && user.last_name)}</h3> */}
                            </div>
                         
                        }
                        
                            </Col>
                        <Col md={{ span: 16 }}>
                            <h1 style={{ color: '#0099ff' }}>
                                Hi {user.first_name},
                            </h1>
                            <Row>
                                <Col md={{ span: 24}}>
                                    <h2 style={{ fontWeight: "bold" }} className="GrayText">Welcome to Villaride.</h2>
                                </Col>
                            </Row>
    
                            <Row>
                                <Col md={{ span: 24 }}>
                                    <h2 style={{ fontWeight: "normal" }} className="GrayText">
                                    Share a ride with good people headed in the same direction
                                    </h2>
                                    <br/>
                                    <Link to="/post-trip">
                                        <Button type="primary" size='large' icon="plus">Post a Ride</Button>
                                    </Link>
                                    &nbsp;&nbsp;

                                    <Link to="/find-ride">
                                        <Button type="primary" size='large' icon="search" style={{ backgroundColor: '#ff3d00', borderWidth: '0px' }}>Find a Ride</Button>
                                    </Link>
                                </Col>
                            </Row>
                        </Col>
                        </Row>

                        </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.token !== null,
        loggedInUser: state.currentUser,
        token: state.token
    }
}

export default connect(mapStateToProps, null)(Dashboard);
